<template>
  <div class="page-content">
    <div class="page-banner program_banner">
      <div class="page-banner-content">
      <p><span class="pc-browser">VALSE&nbsp;&nbsp;2026&nbsp;&nbsp;</span>HOTEL & VENUE</p>
      </div>
    </div>
    <div class="main-container" v-show="true">
      <div class="content-item-grp">
        <div class="content-item">
          <div class="item-title"  v-show="false">
            <span class="item-title-content">交通和酒店</span>
          </div>
          <div class="item-content" v-show="false">
            <p class="content-null-info">敬请期待......</p>
          </div>
          <div class="item-title">
            <span class="item-title-content">
              <div>会议协议酒店列表</div>
            </span>
          </div>
          <div class="item-content">
            <!-- <div class="traffic-detail">
              <div class="traffic-detail-text">
                <p>为方便各位老师和同学参会，组委会前期调研了会场周边的酒店，<a href="./static/VALSE2025_zhusujiudian_0512.xlsx" download class="download-link">点击下载酒店列表</a>，适宜选择，同时也非常建议参会者自行通过携程等公共平台自行搜索会场附近酒店。
                </p>
              </div>
            </div> -->
            <table>
        <thead>
            <tr>
                <th>序号</th>
                <th>酒店名称</th>
                <th>星级</th>
                <th>距离洲际</th>
                <th>房型</th>
                <th>协议价</th>
                <th>早餐</th>
                <th>数量</th>
                <th>联系人及电话</th>
                <th>预定方式</th>
            </tr>
        </thead>
        <tbody>

          <tr><td rowspan="2">1</td><td rowspan="2" style="font-weight:bold;">武汉洲际酒店</td><td rowspan="2">豪华型</td><td rowspan="2">/</td><td>豪华大床房</td><td class="highlight">¥650</td><td>单早</td><td>40</td><td rowspan="2" class="left-align">订房电话 027-84556062</td><td rowspan="2" class="left-align" style="font-size:11px; color:#666;">自行联系订房电话
报VALSE2026或视觉与学习青年学者研讨会订房</td></tr><tr><td>豪华双床房</td><td class="highlight">¥650</td><td>单早</td><td>140</td></tr><tr><td rowspan="2">2</td><td rowspan="2" style="font-weight:bold;">城市便捷酒店（武汉国博中心前进村地铁站店）</td><td rowspan="2">舒适型</td><td rowspan="2">2km</td><td>大床房</td><td class="highlight">¥200</td><td>单早</td><td>37</td><td rowspan="2" class="left-align">订房电话 18163306858/15007151369</td><td rowspan="2" class="left-align" style="font-size:11px; color:#666;">自行联系订房电话
报VALSE2026或视觉与学习青年学者研讨会订房</td></tr><tr><td>双床房</td><td class="highlight">¥220</td><td>双早</td><td>23</td></tr><tr><td rowspan="2">3</td><td rowspan="2" style="font-weight:bold;">曼居酒店（武汉国际博览中心店）</td><td rowspan="2">舒适型</td><td rowspan="2">2.4km</td><td>曼享单人间</td><td class="highlight">¥350</td><td>双早</td><td>19</td><td rowspan="2" class="left-align">王国庆 18971695710</td><td rowspan="2" class="left-align" style="font-size:11px; color:#666;">自行联系销售经理
报VALSE2026或视觉与学习青年学者研讨会订房</td></tr><tr><td>曼享双床房</td><td class="highlight">¥350</td><td>双早</td><td>77</td></tr><tr><td rowspan="2">4</td><td rowspan="2" style="font-weight:bold;">玫悦酒店（武汉国博中心北地铁站）</td><td rowspan="2">舒适型</td><td rowspan="2">2.4km</td><td>大床房</td><td class="highlight">¥258</td><td>无早</td><td>19</td><td rowspan="2" class="left-align">程拼拼 18971348188</td><td rowspan="2" class="left-align" style="font-size:11px; color:#666;">自行联系销售经理
报VALSE2026或视觉与学习青年学者研讨会订房</td></tr><tr><td>双床房</td><td class="highlight">¥238</td><td>无早</td><td>60</td></tr><tr><td rowspan="3">5</td><td rowspan="3" style="font-weight:bold;">维也纳酒店（武汉国博中心南地铁站店）</td><td rowspan="3">舒适型</td><td rowspan="3">3km</td><td>大床房</td><td class="highlight">¥380</td><td>双早</td><td>56</td><td rowspan="3" class="left-align">吴含 18120419025</td><td rowspan="3" class="left-align" style="font-size:11px; color:#666;">自行联系销售经理
报VALSE2026或视觉与学习青年学者研讨会订房</td></tr><tr><td>高级双床房</td><td class="highlight">¥400</td><td>双早</td><td>36</td></tr><tr><td>豪华双床房</td><td class="highlight">¥420</td><td>双早</td><td></td></tr><tr><td rowspan="2">6</td><td rowspan="2" style="font-weight:bold;">武汉国博华美达广场酒店</td><td rowspan="2">豪华型</td><td rowspan="2">3.6km</td><td>大床房</td><td class="highlight">¥520</td><td>单早</td><td>107</td><td rowspan="2" class="left-align">覃语 18971409212</td><td rowspan="2" class="left-align" style="font-size:11px; color:#666;">自行联系销售经理
报VALSE2026或视觉与学习青年学者研讨会订房</td></tr><tr><td>双床房</td><td class="highlight">¥520</td><td>双早</td><td>51</td></tr><tr><td rowspan="3">7</td><td rowspan="3" style="font-weight:bold;">武汉汉阳雅高美爵酒店</td><td rowspan="3">高档型</td><td rowspan="3">3.7km</td><td>豪华套房</td><td class="highlight">¥650</td><td>双早</td><td>11</td><td rowspan="3" class="left-align">冯雯 15972977644</td><td rowspan="3" class="left-align" style="font-size:11px; color:#666;">自行联系销售经理
报VALSE2026或视觉与学习青年学者研讨会订房</td></tr><tr><td>大床房</td><td class="highlight">¥450</td><td>单早</td><td>101</td></tr><tr><td>双床房</td><td class="highlight">¥450</td><td>双早</td><td>103</td></tr><tr><td rowspan="4">8</td><td rowspan="4" style="font-weight:bold;">亚朵酒店（武汉国际博览中心四新北路店）</td><td rowspan="4">高档型</td><td rowspan="4">3.8km</td><td>高级大床房</td><td class="highlight">¥500</td><td>单早</td><td>24</td><td rowspan="4" class="left-align">丁苗 13407134656</td><td rowspan="4" class="left-align" style="font-size:11px; color:#666;">自行联系销售经理
报VALSE2026或视觉与学习青年学者研讨会订房</td></tr><tr><td>行政大床房</td><td class="highlight">¥550</td><td>单早</td><td>26</td></tr><tr><td>几木大床房</td><td class="highlight">¥600</td><td>单早</td><td>48</td></tr><tr><td>双床房</td><td class="highlight">¥600</td><td>双早</td><td>41</td></tr><tr><td rowspan="2">9</td><td rowspan="2" style="font-weight:bold;">格菲酒店（武汉国际博览中心四新南路地铁站店）</td><td rowspan="2">高档型</td><td rowspan="2">3.8km</td><td>豪华大床房</td><td class="highlight">¥330</td><td>单早</td><td>50</td><td rowspan="2" class="left-align">汪经理 13294279996</td><td rowspan="2" class="left-align" style="font-size:11px; color:#666;">自行联系销售经理
报VALSE2026或视觉与学习青年学者研讨会订房</td></tr><tr><td>豪华双床房</td><td class="highlight">¥330</td><td>双早</td><td>28</td></tr><tr><td rowspan="2">10</td><td rowspan="2" style="font-weight:bold;">全季武汉汉阳江滩马鹦路地铁站酒店</td><td rowspan="2">高档型</td><td rowspan="2">4.1公里</td><td>高级大床房</td><td class="highlight">¥300</td><td>双早</td><td>30</td><td rowspan="2" class="left-align">张经理 15385515720</td><td rowspan="2" class="left-align" style="font-size:11px; color:#666;">自行联系销售经理
报VALSE2026或视觉与学习青年学者研讨会订房</td></tr><tr><td>景观双床房</td><td class="highlight">¥300</td><td>双早</td><td>20</td></tr><tr><td rowspan="2">11</td><td rowspan="2" style="font-weight:bold;">雲泊酒店（武汉国际博览中心四新北路店）</td><td rowspan="2">高档型</td><td rowspan="2">4.2km</td><td>大床房</td><td class="highlight">¥400</td><td>单早</td><td>70</td><td rowspan="2" class="left-align">张苗苗 18171136913</td><td rowspan="2" class="left-align" style="font-size:11px; color:#666;">自行联系销售经理
报VALSE2026或视觉与学习青年学者研讨会订房</td></tr><tr><td>双床房</td><td class="highlight">¥400</td><td>双早</td><td>30</td></tr><tr><td rowspan="2">12</td><td rowspan="2" style="font-weight:bold;">全季武汉沌口永旺梦乐城酒店</td><td rowspan="2">高档型</td><td rowspan="2">4.5公里</td><td>高级大床房</td><td class="highlight">¥320</td><td>双早</td><td>30</td><td rowspan="2" class="left-align">熊经理 15102755447</td><td rowspan="2" class="left-align" style="font-size:11px; color:#666;">自行联系销售经理
报VALSE2026或视觉与学习青年学者研讨会订房</td></tr><tr><td>商务双床房</td><td class="highlight">¥320</td><td>双早</td><td>15</td></tr><tr><td rowspan="2">13</td><td rowspan="2" style="font-weight:bold;">武汉四新国博希尔顿欢朋酒店</td><td rowspan="2">高档型</td><td rowspan="2">4.5km</td><td>高级大床房</td><td class="highlight">¥420</td><td>双早</td><td>85</td><td rowspan="2" class="left-align">古今 17771898883</td><td rowspan="2" class="left-align" style="font-size:11px; color:#666;">自行联系销售经理
报VALSE2026或视觉与学习青年学者研讨会订房</td></tr><tr><td>高级双床房</td><td class="highlight">¥420</td><td>双早</td><td>55</td></tr><tr><td rowspan="2">14</td><td rowspan="2" style="font-weight:bold;">武汉青莲·景合酒店（武汉动物园国际博览中心店）</td><td rowspan="2">豪华型</td><td rowspan="2">4.8km</td><td>大床房</td><td class="highlight">¥438</td><td>双早</td><td>90</td><td rowspan="2" class="left-align">杨丽莎 18672924344</td><td rowspan="2" class="left-align" style="font-size:11px; color:#666;">自行联系销售经理
报VALSE2026或视觉与学习青年学者研讨会订房</td></tr><tr><td>双床房</td><td class="highlight">¥438</td><td>双早</td><td>40</td></tr><tr><td rowspan="2">15</td><td rowspan="2" style="font-weight:bold;">武汉汉阳国博中心枫渡酒店</td><td rowspan="2">高档型</td><td rowspan="2">5km</td><td>大床房</td><td class="highlight">¥260</td><td>双早</td><td>48</td><td rowspan="2" class="left-align">王芬 18707156533</td><td rowspan="2" class="left-align" style="font-size:11px; color:#666;">自行联系销售经理
报VALSE2026或视觉与学习青年学者研讨会订房</td></tr><tr><td>双床房</td><td class="highlight">¥260</td><td>双早</td><td>32</td></tr><tr><td rowspan="2">16</td><td rowspan="2" style="font-weight:bold;">汉庭武汉归元寺钟家村地铁站酒店</td><td rowspan="2">舒适型</td><td rowspan="2">5km</td><td>高级大床房</td><td class="highlight">¥200</td><td>双早</td><td>50</td><td rowspan="2" class="left-align">张经理 15385515720</td><td rowspan="2" class="left-align" style="font-size:11px; color:#666;">自行联系销售经理
报VALSE2026或视觉与学习青年学者研讨会订房</td></tr><tr><td>高级双床房</td><td class="highlight">¥220</td><td>双早</td><td>10</td></tr>
    
        </tbody>
    </table>
          </div>
        </div>
        
        <div class="content-item"  v-show="false">
          <div class="item-title">
            <span class="item-title-content">
              <div>抵达会场交通信息</div>
              <!--<div class="pc-browser">VALSE 2019 HOTEL & VENUE</div>-->
              <!--<div class="mobile-browser">VALSE 2019<br/>HOTEL & VENUE</div>-->
            </span>
          </div>
          <div class="item-content">
            <!--<p class="content-null-info">敬请期待......</p>-->
            <p>会议地点：珠海国际会议中心-C座</p>
            <p>
              交通地址：珠海十字门中央商务区湾仔片区（香洲区银湾路1663号）
            </p>
            <!-- <img src="../../static/images/jiaotong/jiaotong-10.jpg"/> -->
            <!-- <img src="../../static/images/jiaotong/jiaotong-11.jpg"/> -->
          </div>
        </div>
        <div class="content-item" v-show="false">
          <div class="item-title">
            <span class="item-title-content">
              <div>酒店预定信息</div>
              <!--<div class="pc-browser">VALSE 2019 HOTEL & VENUE</div>-->
              <!--<div class="mobile-browser">VALSE 2019<br/>HOTEL & VENUE</div>-->
            </span>
          </div>
          <div class="item-content">
            <div class="traffic-detail">
              <div class="traffic-detail-text">
                <p>点击下载<a target='_blank' href='./static/HYJDLB20210902.xlsx' class='news-item'><b>重庆悦来国际会议中心周围酒店列表</b></a>，同时也非常建议参会者自行通过携程等公共平台自行搜索会场附近酒店。
                </p>
              </div>
            </div>
            
          </div>
        </div>

        <div class="content-item" v-show="false">
          <div class="item-title">
            <span class="item-title-content">
              <div>酒店预定信息</div>
              <!--<div class="pc-browser">VALSE 2019 HOTEL & VENUE</div>-->
              <!--<div class="mobile-browser">VALSE 2019<br/>HOTEL & VENUE</div>-->
            </span>
          </div>
          <div class="item-content">
            <div class="traffic-detail">
              <div class="traffic-detail-text">
                <p>为方便各位老师和同学参会，组委会前期调研了会场周边的酒店，步行范围内可达会场（无锡太湖国际博览中心）的有"无锡君来世尊酒店"、"无锡太湖新城假日酒店"、"无锡太湖新城智选假日酒店"三家酒店。另有豪华型酒店"无锡太湖华邑酒店"距会场2000米，需乘坐地铁4号线2站。其余酒店均位于地铁沿线和交通较为便利的地方，适宜选择。同时也非常建议参会者自行通过携程等公共平台自行搜索会场附近酒店。
                </p>
              </div>
            </div>
            <!-- <img src="../../static/images/jiaotong/jiudian-2.jpg"/> -->
            <!-- <img src="../../static/images/jiaotong/jiaotong-11.jpg"/> -->
          </div>
          <div class="item-content">
            <div class="traffic-detail">
              <div class="traffic-detail-text">
                <p>组委会将在大会网站上公开电子版会议通知，方便各位参会者报销。酒店特惠订房协议价如下：
                </p>
                <p><b>请凭借VALSE 2023订房优惠口令（或报名成功截图）自行与酒店联系人预定，费用自理，先到先得。</b></p>
              </div>
            </div>
            <!-- <img src="../../static/images/jiaotong/jiudian-3.jpg"/>
            <img src="../../static/images/jiaotong/jiudian-5.jpg"/> -->
            <div class="traffic-detail">
            <div class="traffic-detail-text">
                <p>附：无锡君来世尊酒店支付方式【订房需要支付首晚房费担保，并请备注预订人姓名。】</p>
                <div>支付方式一 酒店支付宝账户：Dean.feng@worldhotelgrandjuna.com</div>
                <div>支付方式二 酒店对公银行账户：</div>
                <div>户名：无锡君来世尊酒店有限公司</div>
                <div>账号：24410188000032757  </div>
                <div>开户行：江苏银行无锡诚业支行</div>
              </div>
            </div>
          </div>
        </div>
        <div class="content-item" v-show="false">
          <div class="item-title">
            <span class="item-title-content">
              <div>交通情况</div>
              <!--<div class="pc-browser">VALSE 2019 HOTEL & VENUE</div>-->
              <!--<div class="mobile-browser">VALSE 2019<br/>HOTEL & VENUE</div>-->
            </span>
          </div>
          <div class="item-content">
            <p>交通情况概览</p>
            <img src="../../static/images/jiaotong/jiaotong-gailan.png" />
            <p>打车请搜索"珠海国际会展中心-C座（C1门）"</p>
            <!-- <img src="../../static/images/jiaotong/jiaotong-11.jpg"/> -->
          </div>
          <div class="item-content">
            <p>
              <span class="start-address"><i class="el-icon-location"></i>珠海九洲机场</span>
              <!-- <span class="address-info-text">(合肥市蜀山区高刘镇)</span> -->
            </p>
            <p>
              <span class="line-tyep"><i class="el-icon-d-arrow-right"></i> 打车线路【全程估计22分钟】</span>

            </p>
            <div class="traffic-detail">
              <div class="traffic-detail-text">
                距离会场约14.6公里，出租车约34元。
              </div>
            </div>
            <img src="../../static/images/jiaotong/jiaotong-1.png"/>
          </div>
          <div class="item-content">
            <p>
              <span class="start-address"><i class="el-icon-location"></i>珠海金湾机场</span>
            </p>
            <p>
              <span class="line-tyep"><i class="el-icon-d-arrow-right"></i> 打车线路【全程估计29分钟】</span>
            </p>
            <div class="traffic-detail">
              <div class="traffic-detail-text">
                距离会场约30.5公里，打车约80元，高速费约14元。
              </div>
            </div>
            <img src="../../static/images/jiaotong/jiaotong-2.png"/>
            
          </div>
        <div class="item-content">
            <p>
              <span class="start-address"><i class="el-icon-location"></i>十字门站</span>
            </p>
           
            <p>
              <span class="line-tyep"><i class="el-icon-d-arrow-right"></i> 步行线路【全程估计6分钟】</span>
            </p>
            <div class="traffic-detail">
              <div class="traffic-detail-text">
                距离会场约373米。
              </div>
            </div>
            <img src="../../static/images/jiaotong/jiaotong-5.png"/>
          </div>

        <div class="item-content">
            <p>
              <span class="start-address"><i class="el-icon-location"></i>珠海站</span>
            </p>
           
            <p>
              <span class="line-tyep"><i class="el-icon-d-arrow-right"></i> 打车线路【全程估计14分钟】</span>
            </p>
            <div class="traffic-detail">
              <div class="traffic-detail-text">
                距离会场约8.4公里，出租车约26元。
              </div>
            </div>
            <img src="../../static/images/jiaotong/jiaotong-6.png"/>
          </div>

        <div class="item-content">
            <p>
              <span class="start-address"><i class="el-icon-location"></i>前山站</span>
            </p>
           
            <p>
              <span class="line-tyep"><i class="el-icon-d-arrow-right"></i> 打车线路【全程估计15分钟】</span>
            </p>
            <div class="traffic-detail">
              <div class="traffic-detail-text">
                距离会场约8.8公里，出租车约27元。
              </div>
            </div>
            <img src="../../static/images/jiaotong/jiaotong-7.png"/>
          </div>

        <div class="item-content">
            <p>
              <span class="start-address"><i class="el-icon-location"></i>珠海北站</span>
            </p>
           
            <p>
              <span class="line-tyep"><i class="el-icon-d-arrow-right"></i> 打车线路【全程估计34分钟】</span>
            </p>
            <div class="traffic-detail">
              <div class="traffic-detail-text">
                距离会场约29.8公里，出租车约75元，高速费约2元。
              </div>
            </div>
            <img src="../../static/images/jiaotong/zhuhaibei.jpg"/>
          </div>

        <div class="item-content">
            <p>
              <span class="start-address"><i class="el-icon-location"></i>深圳市</span>
            </p>
           
            <p>
              <span class="line-tyep"><i class="el-icon-d-arrow-right"></i> 高铁线路【全程估计2小时4分钟】</span>
            </p>
            <div class="traffic-detail">
              <div class="traffic-detail-text">
                深圳北站-珠海站（车程约1小时50分钟，高铁二等座费用约144.5元）；<br/>珠海站-珠海国际会展中心（车程约14分钟，出租车约25元）。
              </div>
            </div>

            <p>
              <span class="line-tyep"><i class="el-icon-d-arrow-right"></i> 驾车线路【全程估计1小时40分钟】</span>
            </p>
            <div class="traffic-detail">
              <div class="traffic-detail-text">
                深圳市-珠海国际会展中心（全程约120公里，高速费约114元）。
              </div>
            </div>

            <img src="../../static/images/jiaotong/jiaotong-9.png"/>
          </div>

      <div class="item-content">
            <p>
              <span class="start-address"><i class="el-icon-location"></i>广州市</span>
            </p>
           
            <p>
              <span class="line-tyep"><i class="el-icon-d-arrow-right"></i> 动车线路【全程估计1小时14分钟】</span>
            </p>
            <div class="traffic-detail">
              <div class="traffic-detail-text">
                广州南站-珠海站（车程约1小时，动车二等座费用约70元）；<br/>珠海站-珠海国际会展中心（车程约14分钟，出租车约25元）。
              </div>
            </div>

            <p>
              <span class="line-tyep"><i class="el-icon-d-arrow-right"></i> 驾车线路【全程估计1小时50分钟】</span>
            </p>
            <div class="traffic-detail">
              <div class="traffic-detail-text">
                广州市-珠海国际会展中心（全程约135公里，高速费约69元）。
              </div>
            </div>

            <img src="../../static/images/jiaotong/jiaotong-10.png"/>
      </div>
    </div>

      </div>
    </div>
    <div class="footer">
      <p>© VALSE 2026 All rights reserved</p>
      <!--<img src="../../static/images/other-footer-bg.png"/>-->
    </div>
  </div>
</template>

<script>
    export default {
        name: "Hotel"
    }
</script>

<style scoped>
  .program_banner{
    background-image: url("../../static/images/sub_banner/10.jpg");
    background-size: 100% 100% ;
  }
  .item-content{
    padding-left: 16px;
    padding-right: 16px;
  }
  .item-content img{
    width: 100%;
  }

  .footer{
    /* position: fixed; */
    bottom: 0;
  }
  .start-address{
    color: red;
    font-size: 18px;
    font-weight: 700;
  }
  .address-info-text{
    font-size: 16px;
  }
  .line-tyep{
    color: #0053a1;
    font-weight: 500;
  }
  .traffic-detail{
    padding-left: 18px;


  }
  .traffic-detail .traffic-detail-text{
    text-align: left;
  }
  .traffic-detail-text-label{
    font-weight: 500;
  }
  .hotel-img{
    width: 400px;
    margin: 0 auto;
  }
  .text-left{
    text-align: left;
  }
  .templete-div{
    background-color:#303133;
    color: white;
    padding-left: 16px;
    padding: 16px;
  }
  .content-item{
    /* width: 60%; */
    margin: 70px auto;
    margin-bottom: 30px;
  }
  @media screen  and (max-width: 800px){
    .content-item {
      margin: 70px auto;
      margin-bottom: 30px;
    }
    .program_banner{
      /*background-image: url("../../static/images/hotel_mobile_banner.jpg");*/
      background-position: 92% 100%;
    }
    .hotel-img{
      width: 280px;
      margin: 0 auto;
    }
    /*.item-title-content{*/
      /*position: relative;*/
      /*top:-38px;*/
    /*}*/
    /*.item-content{*/
      /*margin-top: -30px;*/
    /*}*/
  }
  .download-link {
    color: #409EFF;
    text-decoration: none;
  }
  .download-link:hover {
    text-decoration: underline;
  }
  table {
            width: 100%;
            border-collapse: collapse;
            background-color: white;
        }
        th {
            background-color: #f2f4f4;
            color: #1a5276;
            font-weight: bold;
            text-align: center;
            border: 1px solid #d5dbdb;
            padding: 8px;
            white-space: nowrap;
        }
        td {
            border: 1px solid #d5dbdb;
            padding: 6px;
            text-align: center;
            vertical-align: middle;
        }
        tr:nth-child(even) {
            background-color: #f9f9f9;
        }
        .highlight {
            color: #c0392b;
            font-weight: bold;
        }
        .contact {
            text-align: left;
            font-size: 8pt;
        }
        .method {
            font-size: 8pt;
            color: #666;
            max-width: 150px;
            text-align: left;
        }
</style>



// WEBPACK FOOTER //
// src/components/Hotel.vue